const NAME = 'LYTICS';
const CNameMapping = {
  [NAME]: NAME,
  Lytics: NAME,
  lytics: NAME,
};

export { NAME, CNameMapping };
